import type { Theme } from '../../types/theme';

export const mistralTheme: Theme = {
  id: 'mistral',
  name: 'Mistral AI',
  description: 'French-engineered minimalism with purple-toned elegance',
  sourceDesignMd: 'https://github.com/nexu-io/open-design/blob/main/design-systems/mistral-ai/DESIGN.md',
  visualKeywords: ['minimal', 'purple accent', 'French', 'elegant', 'modern'],
  colors: {
    background: '#ffffff',
    surface: '#ffffff',
    surfaceElevated: '#ffffff',
    textPrimary: '#1a1a1a',
    textSecondary: '#666666',
    textMuted: '#666666',
    border: '#e5e5e5',
    borderSubtle: '#dbdbdb',
    primary: '#7c3aed',
    primaryHover: '#8b49fc',
    primaryActive: '#5e1ccf',
    accent: '#7c3aed',
    onPrimary: '#ffffff',
    success: '#22c55e',
    warning: '#f59e0b',
    error: '#ef4444',
  },
  typography: {
    headingFont: 'Inter, system-ui, sans-serif',
    bodyFont: 'Inter, system-ui, sans-serif',
    monoFont: 'JetBrains Mono, monospace',
    headingWeight: '600',
    bodyWeight: '400',
    letterSpacingHeading: '-0.02em',
    letterSpacingBody: '0',
  },
  radius: {
    button: '6px',
    card: '8px',
    panel: '8px',
    badge: '4px',
    input: '6px',
  },
  shadow: {
    card: '0 1px 3px rgba(0,0,0,0.1)',
    elevated: '0 4px 12px rgba(0,0,0,0.15)',
    button: '0 1px 2px rgba(0,0,0,0.1)',
    none: 'none',
  },
  layout: {
    maxWidth: '1280px',
    sectionSpacing: '80px',
    cardPadding: '24px',
    navHeight: '64px',
  },
  mood: {
    density: 'low',
    tone: 'elegant',
    productFit: [],
    bestFor: [],
    notGoodFor: [],
  },
};
